import { createSelector } from 'reselect'
import { getFormValues } from 'redux-form'
import get from 'lodash/get'
import map from 'lodash/map'
import merge from 'lodash/merge'
import isEmpty from 'lodash/isEmpty'
import some from 'lodash/some'
import pickBy from 'lodash/pickBy'
import omitBy from 'lodash/omitBy'
import { FORM_FIELD_TYPES, HIDDEN_FIELDS_SOURCES } from './constants'
import { getUrlParamValue } from 'shared/helpers/UrlHelper'

const SELECT_FIELD_TYPE = 'select'

const getFormFields = (state, props) => get(props, 'config.form.fields')

const getFormSelectFields = (state, props) => {
  const fields = getFormFields(state,props)
  const formValues = getFormValues(props.form)(state)
  const selectFields = pickBy(fields, (field) => field.type == SELECT_FIELD_TYPE)
  let res = {}

  map(selectFields, (field, key) => {
    if (isEmpty(field.dependent_field)) {
      res[key] = field
    }
    else {
      const { name, values } = field.dependent_field
      const currentDepFieldValue = get(formValues, name, '').toLowerCase()
      const isDepValueExist = some(values, (val) => {
        return val.toLowerCase() == currentDepFieldValue
      })
      if (isDepValueExist) {
        res[key] = {
          ...field,
          selection_values: field.selection_values[currentDepFieldValue]
        }
      }
    }
  })

  return res
}

export const getFormFieldsConfig = createSelector(
  getFormSelectFields,
  getFormFields,
  (getFormSelectFields, getFormFields) => {
    const fieldsWithoutSelect = omitBy(getFormFields, (field) => field.type == SELECT_FIELD_TYPE)
    return merge(fieldsWithoutSelect, getFormSelectFields)
  }
)

export const getHiddenFieldsInitialValues = createSelector(
  getFormFields,
  (getFormFields) => {
    const hiddenFields = pickBy(getFormFields, (field) => field.type == FORM_FIELD_TYPES.hidden)
    let values = {}

    map(hiddenFields, (field, key) => {
      if (isEmpty(field.value_config)) {
        return
      }
      values[key] = getHiddenFieldValue(field.value_config)
    })
    return values
  }
)

const getHiddenFieldValue = (config) => {
  let value
  switch (config.source) {
    case HIDDEN_FIELDS_SOURCES.queryParams:
      value = getUrlParamValue(window.location.search, config.query_param)
      break
    case HIDDEN_FIELDS_SOURCES.customField:
      const customAttributes = get(FollozeState, 'initialState.board.custom_attributes')
      value = get(customAttributes, `${config.field_name}`)
      break
    case HIDDEN_FIELDS_SOURCES.configuration:
    default:
      value = config.value
  }
  return value
}
